import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";
import type { SearchSuggestion } from "common/types";

async function getSearchSuggestionsRequest(
  workspaceId: string,
): Promise<SearchSuggestion[]> {
  return (await get(`workspaces/${workspaceId}/predefined-search`)).suggestions;
}

export default function useSearchSourceSuggestions() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { leadListSourcesKeys } = getQueryKeys(workspaceId);

  const { data: searchSuggestions, isLoading: isLoadingSearchSuggestions } =
    useQuery({
      queryKey: leadListSourcesKeys.predefinedSearches(),
      queryFn: () => getSearchSuggestionsRequest(workspaceId),
    });

  return { searchSuggestions, isLoadingSearchSuggestions };
}
